import React from "react";
import {View, TouchableOpacity, Text, TextInput, FlatList} from "react-native";
import IconButton from "@material-ui/core/IconButton";
import TripOriginIcon from "@material-ui/icons/TripOrigin";
import ClearIcon from "@material-ui/icons/Clear";
import DirectionsWalkIcon from "@material-ui/icons/DirectionsWalk";
import DirectionsBikeIcon from "@material-ui/icons/DirectionsBike";
import DirectionsBoatIcon from "@material-ui/icons/DirectionsBoat";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import ListItemAvatar from "@material-ui/core/ListItemAvatar";
import Avatar from "@material-ui/core/Avatar";
import {TextField} from "@material-ui/core";
import ButtonGroup from "@material-ui/core/ButtonGroup";
import Button from "@material-ui/core/Button";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import logo from '../logo_small.png';
import skHuLogoHu from '../Logo_color_SKHU_HU_RGB.jpg';
import skHuLogoSk from '../Logo_color_SKHU_SK_RGB.jpg';
import skHuLogoEn from '../Logo_color_SKHU_EN_RGB.jpg';
import erdfHu from '../skhu_erdf_hu.png';
import erdfSk from '../skhu_erdf_sk.png';
import erdfEn from '../skhu_erdf_en.png';
import slogenHu from '../SKHU_slogen_hu.png';
import slogenSk from '../SKHU_slogen_sk.png';
import slogenEn from '../SKHU_slogen_en.png';
import {ScrollView} from "react-native-web";
import {Popup} from "react-leaflet";

class ItineraryList extends React.Component {

    static getDerivedStateFromProps(props, state) {
        props.updatePath(props.itinerary, props.profile);
        return props
    }

    renderItem = ({ item, index, move, moveEnd, isActive }) => {
        return (
            <TouchableOpacity
                style={{
                    height: 100,
                    backgroundColor: isActive ? 'blue' : item.backgroundColor,
                    alignItems: 'center',
                    justifyContent: 'center'
                }}
                onLongPress={move}
                onPressOut={moveEnd}
            >
                <Text style={{
                    fontWeight: 'bold',
                    color: 'white',
                    fontSize: 32,
                }}>{item.label}</Text>
            </TouchableOpacity>
        )
    };

    render() {
        let language = window.location.search? window.location.search.substr(10) : "hu";
        return (
            <View style={{width: 400}}>
                <ScrollView>
                <TextField
                    label="Search"
                    placeholder="Search"
                />
                <ButtonGroup variant="contained" alignItems="center">
                    <form onSubmit={e => {
                        e.preventDefault();
                        this.props.changeProfile('foot-hiking');
                    }}>
                        <Button type="submit" variant={this.props.profile.profile === 'foot-hiking' ? 'contained' : 'text'} color='primary'>
                            <DirectionsWalkIcon />
                        </Button>
                    </form>
                    <form onSubmit={e => {
                        e.preventDefault();
                        this.props.changeProfile('cycling-regular');
                    }}>
                        <Button type="submit" variant={this.props.profile.profile === 'cycling-regular' ? 'contained' : 'text'} color='primary'>
                            <DirectionsBikeIcon />
                        </Button>
                    </form>
                </ButtonGroup>
                <List>
                    {this.props.itinerary.map((place, i) =>
                        <ListItem key={i}>
                            {!place.boat && <ListItemIcon>
                                    <TripOriginIcon />
                            </ListItemIcon>}
                            {place.boat && <ListItemIcon>
                                <DirectionsBoatIcon />
                            </ListItemIcon>}
                            <ListItemText primary={place.title} secondary={place.distance && !place.boat ? (place.distance + ' km, ' + Math.round(place.duration / 60) + ' min') : ''} />
                            <ListItemSecondaryAction>
                                <IconButton edge="end" onClick={() => this.props.removePlace(place)}>
                                    <ClearIcon />
                                </IconButton>
                            </ListItemSecondaryAction>
                        </ListItem>
                    )}
                </List>
                </ScrollView>
                <View style={{display: 'flex',  justifyContent:'center', alignItems:'center'}}>
                    <a href="https://www.ipelrowing.eu/"><img src={logo} width="200px;" align="center" alt="logo" /></a>
                    {language === 'hu' && <View>
                        <img src={slogenHu} width="243px;" alt="logo"/>
                        <a href = "http://www.skhu.eu/" >< img src={skHuLogoHu} width="243px;"  alt="logo" /></a>
                        <img src={erdfHu} width="243px;"  alt="logo" />
                    </View>}
                    {language === 'sk' && <View>
                        <img src={slogenSk} width="243px;" alt="logo"/>
                        <a href = "http://www.skhu.eu/" >< img src={skHuLogoSk} width="243px;"  alt="logo" /></a>
                        <img src={erdfSk} width="243px;"  alt="logo" />
                    </View>}
                    {language === 'en' && <View>
                        <img src={slogenEn} width="243px;" alt="logo"/>
                        <a href = "http://www.skhu.eu/" >< img src={skHuLogoEn} width="243px;"  alt="logo" /></a>
                        <img src={erdfEn} width="243px;"  alt="logo" />
                    </View>}
                </View>
            </View>
        )
    }
}

export default ItineraryList
